import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";

import usePermission from "../../config/permissions";
// import { handleErrorToast } from "../CustomFunctions";
import {
    AddwithWhiteCircle,
    CheckGreen,
    DeleteDustbin,
    DropdownArrow,
    PDFIcon,
    Document,
    CloudUpload
} from "../AllSvg";
import Loader from "../Loader";

import { formattedDateLong } from "../Date";
import Dashboardnavbarcopy from "../../layout/Dashboardnavbar";
import { formatCurrencyIndian, handleErrorToast } from "../custom";

// ! *************** Sector Crud Models Start ***************

const AddMiscellaneous = ({ getMiscellaneous }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setFormData({
            header_name: "",
            miscellaneous_type: "ProjectbyWise",
            project: "",
            month: "",
            year: "",
            expense: "",
            document: "",
            status: "pending",
            project_details: ""
        });
        setShow(false);
    };
    const handleShow = () => {
        getProjectListData();
        setShow(true);
    };
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

    const [formData, setFormData] = useState({
        header_name: "",
        miscellaneous_type: "ProjectbyWise",
        project: "",
        month: "",
        year: "",
        expense: "",
        document: "",
        status: "pending",
        project_details: ""
    });

    // console.log(formData.miscellaneous_type)

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "header_name", "expense", "status",
            formData.decision === 'Paid' || formData.decision === 'Salary' ? "settlement_amount" : null,
            formData.miscellaneous_type === "Monthbywise" ? "month" : null,
            formData.miscellaneous_type === "Monthbywise" ? "year" : null,
            formData.miscellaneous_type === "ProjectbyWise" ? "project" : null,
            formData.miscellaneous_type === "ProjectbyWise" ? "project_details" : null,
        ].filter(Boolean);


        requiredFields.forEach((field) => {
            console.log(formData[field]);
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        console.log(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                const formDataToSend = new FormData();

                Object.keys(formData).forEach((key) => {
                    if (formData[key] && key !== "document") {
                        formDataToSend.append(key, formData[key]);
                    }
                });
                const symbols = "!@#$%^&*()_-+=";
                const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
                const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                const numbers = "0123456789";
                const now = new Date();
                const date = now
                    .toLocaleDateString("en-GB")
                    .split("/")
                    .reverse()
                    .join("-"); // Format: YYYY-MM-DD
                const time = now
                    .toLocaleTimeString("en-GB", { hour12: false })
                    .replace(/:/g, "-"); // Format: HH-MM-SS
                const allChars =
                    symbols + lowercaseLetters + uppercaseLetters + numbers;
                let randomCode = "";
                for (let i = 0; i < 8; i++) {
                    const randomIndex = Math.floor(Math.random() * allChars.length);
                    randomCode += allChars[randomIndex];
                }
                const originalFile = formData.document;
                const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
                const customFile = new File([originalFile], customFileName, {
                    type: originalFile.type,
                });
                if (formData.document) {
                    console.log(File);
                    formDataToSend.append("document", customFile);
                }
                let res = await axios.post(
                    `${BASE_URL}/project/miscellaneous/`,
                    formDataToSend
                );

                if (res.status === 200) {
                    await getMiscellaneous();
                    handleClose();
                    toast.dismiss(loadingToastId);
                    toast.success("Miscellaneous added successfully!");
                } else {
                    toast.dismiss(loadingToastId);
                    toast.error("Failed to add Miscellaneous!");
                }
            } catch (err) {
                //toast Logic
                handleErrorToast(err);
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        } else {

        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, files } = e.target;
        // console.log(files[0])
        let newValue;
        if (type === "file") {
            console.log("file", files[0]);
            newValue = files.length > 0 ? files : null;
        } else {
            newValue = value;
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        if (name === "miscellaneous_type") {
            setFormData({
                ...FormData,
                [name]: newValue,
                month: "",
                project: "",
            });
        }
        setFormData({
            ...formData,
            [name]: newValue,
        });
    };

    const [projectListData, setProjectList] = useState([]);
    const [clientWiseData, setClientWiseData] = useState([]);
    const [buffer, setBuffering] = useState(true); //buffering logic
    const getProjectListData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/project/projectfilterbysubcompany/null/`
            );
            setProjectList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };
    const getClientWiseList = async (projectID) => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const clientdetails = await axios.get(
                `${BASE_URL}/project/client-by-project/${projectID || "null"}/`
            );
            setClientWiseData(clientdetails.data);
        } catch (err) {
            // handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        if (formData.project != "") {
            getClientWiseList(formData.project);
        }

    }, [formData.project]);

    useEffect(() => {
        setFormData({
            ...formData,
            "miscellaneous_type": "ProjectbyWise",
        });
    }, [])
    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    console.log("formData.document")
    console.log(formData)

    return (
        <>
            <button
                title="Add Miscellaneous"
                className="upload-svg"
                onClick={handleShow}
            >
                <AddwithWhiteCircle /> Miscellaneous
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="ourcompany-model"
            >
                <Modal.Header
                    closeButton
                    className="justify-center task-Tab-heading font-weight500    font-size-heading "
                >
                    <Modal.Title> Add Miscellaneous</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-flex-wrap">
                        <div className="flex-column">
                            <label
                                htmlFor="header_name"
                                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                title="header_name"
                            >
                                Name:<span className="required">*</span>
                            </label>
                            <input
                                placeholder="Name"
                                title="header_name"
                                type="text"
                                name="header_name"
                                onChange={handleInputChange}
                                value={formData.header_name}
                                className={`form-input font-weight400 font-size-subheading form-input-background ${errors.header_name
                                    ? "error"
                                    : inputState.header_name
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.header_name && (
                                <span className="error-message font-size-text">
                                    {errors.header_name}
                                </span>
                            )}
                        </div>

                        <div className="flex-column form-group-select">
                            <label
                                htmlFor="miscellaneous_type"
                                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                title="miscellaneous_type"
                            >
                                Miscellaneous Type:
                            </label>
                            <select
                                name="miscellaneous_type"
                                value={formData.miscellaneous_type}
                                onChange={handleInputChange}
                                className={`form-input form-group-selection ${errors.project
                                    ? "error"
                                    : inputState.project
                                        ? "success"
                                        : ""
                                    }`}
                            >
                                <option value="ProjectbyWise">ProjectbyWise</option>
                                <option value="Monthbywise">Monthlywise</option>
                            </select>
                            {/* <DropdownArrow /> */}
                            {errors.miscellaneous_type && (
                                <span className="error-message font-size-text">
                                    {errors.miscellaneous_type}
                                </span>
                            )}
                        </div>
                        {/* {console.log(formData.miscellaneous_type)} */}
                        {formData.miscellaneous_type === "ProjectbyWise" ? (
                            <>
                                <div className="flex-column form-group-select">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Project:<span className="required">*</span>
                                    </label>
                                    <select
                                        name="project"
                                        value={formData.project}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.project
                                            ? "error"
                                            : inputState.project
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Project</option>
                                        {projectListData.map((project) => (
                                            <option key={project.id} value={project.pr_code}>
                                                {project.prebid_prcode}
                                                {project.project_short_name
                                                    ? `-${project.project_short_name}`
                                                    : null}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <DropdownArrow /> */}
                                    {errors.project && (
                                        <span className="error-message">{errors.project}</span>
                                    )}
                                </div>
                                <div className="flex-column form-group-select">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Client Details:<span className="required">*</span>
                                    </label>
                                    <select
                                        name="project_details"
                                        value={formData.project_details}
                                        onChange={handleInputChange}
                                        className={`form-input form-group-selection ${errors.project_details
                                            ? "error"
                                            : inputState.project_details
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select a Client Details</option>
                                        {clientWiseData.normal_client?.map((e) => (
                                            <option key={e.client} value={e.id}>
                                                {e.clientname}
                                            </option>
                                        ))}
                                        {clientWiseData.pr_project?.map((e) => (
                                            <option key={e.client} value={e.id}>
                                                PR-{e.clientname}
                                            </option>
                                        ))}
                                    </select>
                                    {/* <DropdownArrow /> */}
                                    {errors.project_details && (
                                        <span className="error-message">
                                            {errors.project_details}
                                        </span>
                                    )}
                                </div>
                            </>
                        ) : (
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Month:<span className="required">*</span>
                                </label>
                                <select
                                    name="month"
                                    value={formData.month}
                                    onChange={handleInputChange}
                                    className={`form-input ${errors.month ? "error" : inputState.month ? "success" : ""
                                        }`}
                                >
                                    <option value="">Select Month</option>
                                    {months.map((month) => (
                                        <option key={month.value} value={month.value}>
                                            {month.text}
                                        </option>
                                    ))}
                                </select>
                                {errors.month && (
                                    <div className="error-message font-size-text">
                                        {errors.month}
                                    </div>
                                )}
                            </div>
                        )}
                        {formData.miscellaneous_type !== "ProjectbyWise" && <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading">
                                Year:<span className="required">*</span>
                            </label>
                            <select
                                name="year"
                                value={formData.year}
                                onChange={handleInputChange}
                                className={`form-input ${errors.year ? "error" : inputState.year ? "success" : ""
                                    }`}
                            >
                                <option value="">Select Year</option>
                                {years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                            {errors.year && (
                                <div className="error-message font-size-text">
                                    {errors.year}
                                </div>
                            )}
                        </div>}


                        <div className="flex-column">
                            <label
                                htmlFor="expense"
                                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                title="expense"
                            >
                                Expense:<span className="required">*</span>
                            </label>
                            <input
                                id="expense"
                                name="expense"
                                placeholder="Expense"
                                title="expense"
                                type="number"
                                min={0}
                                onWheel={(e) => e.target.blur()}
                                onChange={handleInputChange}
                                value={formData.expense}
                                className={`form-input font-weight400 font-size-subheading form-input-background ${errors.expense
                                    ? "error"
                                    : inputState.expense
                                        ? "success"
                                        : ""
                                    }`}
                            />
                            {errors.expense && (
                                <span className="error-message font-size-text">
                                    {errors.expense}
                                </span>
                            )}
                        </div>

                        <div className="flex-column">
                            <label
                                htmlFor="document"
                                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                                title="document"
                            >
                                Document:
                            </label>
                            <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.document ? 'error' : inputState.document ? 'success' : ''}`}>
                                <label style={{ cursor: 'pointer' }} htmlFor="document">
                                    <CloudUpload />
                                    <span className="form-text-trasformation-uppercase" style={{ marginLeft: "20px" }}>
                                        {formData.document ? formData.document[0].name : 'No file selected'}
                                    </span>
                                </label>
                                <input
                                    placeholder="Document"
                                    title="document"
                                    id="document"
                                    type="file"
                                    name="document"
                                    onChange={handleInputChange}
                                    // value={formData.document}
                                    style={{ display: "none", position: "relative" }}

                                />
                                {formData.document ? (<span className="file-clear" onClick={() => handleFileClear('document')}>
                                    Clear
                                </span>) : null}
                                {errors.document && (
                                    <span className="error-message font-size-text">
                                        {errors.document}
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="button-models-gap-116 pr-20">
                        <button
                            className="model-button font-weight500 model-button-cancel"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button font-weight500 model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            Add
                        </button>
                    </div>

                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const ApproveMiscellaneous = ({ i, getMiscellaneous }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/project/miscellaneousupdate/${i.id}/`,
                {
                    status: "approved",
                }
            );

            if (res.status === 200) {
                await getMiscellaneous();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Miscellaneous approved successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Approve Miscellaneous"
                className="model-edit-button"
                onClick={handleShow}
            >
                <CheckGreen />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Approve Miscellaneous {i.header_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to Approve Miscellaneous {i.header_name}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-submit"
                            >
                                Approve
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const RejectMiscellaneous = ({ i, getMiscellaneous }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitRejected = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.put(
                `${BASE_URL}/project/miscellaneousupdate/${i.id}/`,
                {
                    status: "rejected",
                }
            );

            if (res.status === 200) {
                await getMiscellaneous();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Miscellaneous rejected ");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Rejected Miscellaneous"
                className="model-delete-button"
                onClick={handleShow}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                >
                    <path
                        d="M13.5 4.5L4.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                    <path
                        d="M4.5 4.5L13.5 13.5"
                        stroke="#F72B50"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    />
                </svg>
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Rejected Miscellaneous {i.header_name}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to rejected Miscellaneous {i.header_name}
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitRejected}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Rejected
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteMiscellaneous = ({ i, getMiscellaneous }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(
                `${BASE_URL}/project/miscellaneousupdate/${i.id}/`
            );

            if (res.status === 200) {
                await getMiscellaneous();
                setShow(false);
                toast.dismiss(loadingToastId);
                toast.success("Miscellaneous deleted successfully");
            } else {
                alert(res);
            }
        } catch (err) {
            //toast Logic
            handleErrorToast(err);
        } finally {
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Delete Miscellaneous"
                className="model-delete-button"
                onClick={handleShow}
            >
                <DeleteDustbin />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Miscellaneous of "{i.header_name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Miscellaneous ?
                        <div className="button-models">
                            <button
                                className="model-button   font-weight500    model-button-cancel "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const Miscellaneous = () => {
    const [buffer, setBuffering] = useState(true); //buffering logic

    const [toggleStatus, setToggleStatus] = useState("pending");
    const [sectorData, setSectorData] = useState([]);

    const getMiscellaneous = async () => {
        setBuffering(true); // Start Buffering
        let url;
        try {
            url = `${BASE_URL}/project/miscellaneousfilterbystatus/${toggleStatus}/`;

            const sub = await axios.get(url);

            setSectorData(sub.data);
        } catch (err) {
            handleErrorToast(err); // Toast Logic
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getMiscellaneous();
    }, [toggleStatus]);
    const months = [
        { text: "January", value: 1 },
        { text: "February", value: 2 },
        { text: "March", value: 3 },
        { text: "April", value: 4 },
        { text: "May", value: 5 },
        { text: "June", value: 6 },
        { text: "July", value: 7 },
        { text: "August", value: 8 },
        { text: "September", value: 9 },
        { text: "October", value: 10 },
        { text: "November", value: 11 },
        { text: "December", value: 12 },
    ];

    const role = sessionStorage.getItem("role");
    const department = sessionStorage.getItem('department')

    const [projectListData, setProjectList] = useState([]);

    const getProjectListData = async () => {
        setBuffering(true); //buffering logic // Start Buffering
        try {
            const res = await axios.get(
                `${BASE_URL}/project/projectfilterbysubcompany/null/`
            );
            setProjectList(res.data);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering(false); // End Buffering
        }
    };

    useEffect(() => {
        getProjectListData();
    }, []);
    return (
        <>
            <Dashboardnavbarcopy name="Miscellaneous Expense" url="Expenses" />

            <div className="content-tabs">
                <div className="table-css-white-background">
                    <div className="table-heading-flex">
                        <div className="repo-heading font-weight500 font-size-heading">
                            Miscellaneous Expense
                        </div>
                        <div className="field-cont">
                            <div className="table-searchh-new dropdown-container field-cont-div">
                                <select
                                    onChange={(e) => setToggleStatus(e.target.value)}
                                    value={toggleStatus}
                                    className="dropdown-timesheet font-size-subheading  "
                                >
                                    <option value="null">All</option>
                                    <option value="pending">Pending</option>
                                    <option value="approved">Approved</option>
                                    <option value="rejected">Rejected</option>
                                </select>
                            </div>

                            {department === "Accounts" &&
                                <AddMiscellaneous
                                    getMiscellaneous={getMiscellaneous}
                                    sectorList={sectorData}
                                />}
                        </div>
                    </div>
                    {/* <SectorsDetailForm /> */}
                    <div className="table-box height-73vh">
                        <table className="table-css">
                            <thead className="table-heading">
                                <tr className="custom-table-head-tr ">
                                    <th className="align-left">ID</th>
                                    <th className="align-left">Heading Name</th>
                                    <th className="align-left">Miscellanous Type</th>
                                    <th className="align-center">Project</th>
                                    <th className="align-center width-5vw">Client</th>
                                    <th className="align-center">Month</th>
                                    <th className="align-center">Year</th>
                                    <th className="align-center">Expense</th>
                                    <th className="align-center">Document</th>
                                    <th className="align-right">Action</th>
                                </tr>
                            </thead>
                            {buffer ? (
                                <Loader />
                            ) : (
                                <tbody>
                                    {sectorData
                                        // ?.filter((e) =>
                                        //     e.status === toggleStatus
                                        // )
                                        // .sort((a, b) =>
                                        //     a.booking_date.localeCompare(b.booking_date, "en", { ignorePunctuation: true })
                                        // )
                                        .map((i, index) => (
                                            <React.Fragment key={index}>
                                                <tr className="tr-border-bottom">
                                                    <td colSpan="6"></td>
                                                </tr>
                                                <tr className="custom-table-head-td">
                                                    <td className="align-left">{index + 1}</td>
                                                    <td className="align-left">{i.header_name}</td>
                                                    <td className="align-left ">
                                                        {i.miscellaneous_type ? i.miscellaneous_type : "-"}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.project_name ? i.project_name : '-'}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.client_name_name ? i.client_name_name : '-'}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.month
                                                            ? months.map((monthname) => {
                                                                if (monthname.value == i.month) {
                                                                    return <>{monthname?.text}</>;
                                                                }
                                                                return null;
                                                            })
                                                            : "-"}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.year ? i.year : "-"}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.expense ? i.expense : "-"}
                                                    </td>
                                                    <td className="align-center form-text-trasformation-uppercase">
                                                        {i.document ? (
                                                            <a href={i.document}>
                                                                <Document />
                                                            </a>
                                                        ) : "-"}
                                                    </td>
                                                    <td className="align-right ">
                                                        {role === "HOD" ?
                                                            <div className="">
                                                                {i.status === "pending" && (
                                                                    <>
                                                                        <ApproveMiscellaneous
                                                                            i={i}
                                                                            getMiscellaneous={getMiscellaneous}
                                                                        />
                                                                        <RejectMiscellaneous
                                                                            i={i}
                                                                            getMiscellaneous={getMiscellaneous}
                                                                        />
                                                                    </>
                                                                )}
                                                                {i.status === "approved" && (
                                                                    <RejectMiscellaneous
                                                                        i={i}
                                                                        getMiscellaneous={getMiscellaneous}
                                                                    />
                                                                )}
                                                                {i.status === "rejected" && (
                                                                    <ApproveMiscellaneous
                                                                        i={i}
                                                                        getMiscellaneous={getMiscellaneous}
                                                                    />
                                                                )}
                                                            </div>
                                                            :
                                                            <DeleteMiscellaneous
                                                                i={i}
                                                                getMiscellaneous={getMiscellaneous}
                                                            />
                                                        }
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))}
                                </tbody>
                            )}
                        </table>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </div>
            </div>
        </>
    );
};

export default Miscellaneous;
